import { ReactElement } from 'react';
import { SectionEditDialog } from '~/components/shared/AccountArea';
import type { IUserCredentials } from '~/models/UserCredentials';

interface IRequireCredentialsProps {
  title: string;
  dataCy: string;
  credentials: IUserCredentials | undefined;
  onClose: () => void;
  /** The section's form, mounted once the credentials are in so it starts from them. */
  children: (credentials: IUserCredentials) => ReactElement;
}

/**
 * For the sections that save the credentials PATCH (it replaces the whole
 * object): until the location's credentials load, the dialog shows a spinner and
 * cannot save, so a save can never start from empty software or insurance.
 */
export const RequireCredentials = ({
  title,
  dataCy,
  credentials,
  onClose,
  children,
}: IRequireCredentialsProps) =>
  credentials ? (
    children(credentials)
  ) : (
    <SectionEditDialog
      title={title}
      dataCy={dataCy}
      onClose={onClose}
      onSave={async () => {}}
      canSave={false}
      isLoading
    />
  );
